/**
 * Created by shiyonggao on 2019/1/28.
 */

import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
const lodash = require('lodash');

//加载数据模块
import Module_Access from './modules/get_access_info';
import Module_User from './modules/get_user_info';
import Module_Server from './modules/get_server_info';
import Module_Logo from './modules/get_app_logo';
import Module_Package from './modules/get_package_info';
import Module_Post_order from  './modules/post_order';


//初始化应用配置信息
const Common = require('../common/common');
const AppConfig = require('../common/config');

/**
 * 适配页面请求参数
 * @param appconfig
 */
Common.initConfigInfo(AppConfig);

/**
 * 根据请求域名自己适配config文件
 * @param appconfig
 */
Common.domainByResetConfigInfo(AppConfig);


Vue.use(Vuex);
Vue.use(VueI18n);

//加载语言信息，详情：https://www.cnblogs.com/rogerwu/p/7744476.html i18n.getLocaleMessage(AppConfig.PARAMS.lang) 获取语言包的方法
const i18n = new VueI18n({
    locale: AppConfig.PARAMS.lang,
    messages: require('../language/lang_config')
});


const handle = {
    updateAjax(state){
        let status = true;
        for(let key in state.$pageLoadAjaxDone){
            if(!state.$pageLoadAjaxDone[key]){
                status = false;
            }
        }
        if(status){
            state.$pageLoadedIcon = false;
            state.$pageLoadedDone = true;
        }
    },

    popDeflaut : {
        show: false,
        isIframe : false,
        iframeUrl : null,
        iframeWH : {
            height: 0,
            width: 0,
        },
        title: 'Zaplata Przez Telefon',
        desc: 'Desde el 1 de Enero de 2015 en la CEE se a aplicar el IVA en los precios, ver los detalles EU VAT Legislation',
        btn: {
            yes: true,
            no: false
        },
        callback : null,
        closeCallback : null,
    },

    getCustomCssUrl(state, className){

        if(!className) {
            className = 'main';
        }

        let theme = state.$appConfig.getThemeValue();
        let version = state.$appConfig.version;
        let port = state.$devPort;
        let host = state.$isDebug ? `http://localhost:${port}` : state.$appConfig.host;
        return `${host}/static/${theme}/${className}.css?version=${version}`;
    },

    getFooterUrl(state){
        let lang = state.$common.lang2[state.$appConfig.PARAMS.lang],
            gameCode = state.$appConfig.PARAMS.merchant_shop_code,
            url = state.$appConfig.www_footer.replace('@domain@', document.domain).replace('@lang@', lang).replace('@gamecode@', gameCode);
        if (gameCode.includes('naruto')) {
            url = 'https://www.oasgames.com/?a=widget&m=footer&lang='+lang+'&gcode='+gameCode;
        }
        return url;
    }
};

const store = new Vuex.Store({
    modules: {
        Module_Access,
        Module_User,
        Module_Package,
        Module_Server,
        Module_Logo,
        Module_Post_order,
    },
    state:{
        $isDebug : process.env.NODE_ENV === 'development'? true: false,
        $devPort : 8091,
        $appConfig : Object.assign({},AppConfig) ,
        $i18n: i18n,
        $lang : i18n.getLocaleMessage(AppConfig.PARAMS.lang),
        $common: Common,
        $pageLoadedIcon : true,
        $pageLoadedDone: false,
        $packageLoadedDoen: false,
        $noChannelData: false,  //无渠道配置
        $pageLoadAjaxDone:{
            user: false,
            serverList: false,
            packageList: false,
            appAccess : false,
            cssInit : false,
            logo: false,
        },
        $modulList : AppConfig.TPL['t1'],
        $countryModuleCustomData : {},
        $popStatus : handle.popDeflaut,
        $footerUrl : null,
        $_: lodash,
        $lodash : lodash
    },

    actions : {
        /**
         * 关闭弹出UI
         * @param state
         * @param commit
         */
        $POP_HIDE_HANDLE({state, commit}){
            commit('CHANGE_POP_CLOSE_STATUS', handle.popDeflaut);
            commit('LOADING', false, {root: true});
        },

        /**
         * 显示弹出UI
         * @param state
         * @param commit
         * @param args
         */
        $POP_SHOW_HANDLE({state, commit}, args){
            let options = lodash.extend({}, handle.popDeflaut, args);
            commit('CHANGE_POP_SHOW_HANDLE', options);
            commit('LOADING', true, {root: true});
        },

        /**
         * 弹出UI确认按钮执行事件
         * @param state
         * @param commit
         * @param args
         */
        $POP_CONFIRM_HANDLE({state, commit}, args){
            commit('POP_CONFIRM_HANDLE', handle.popDeflaut);
            commit('LOADING', false, {root: true});
        },

        /**
         * 加载样式表
         * @param state
         * @param commit
         */
        $LOAD_STYLE_HANDE({state, commit}, args){
            if (args) {
                let url = handle.getCustomCssUrl(state, args.className);
                Common.loadCSS(url, function () {
                    console.log('加载自定义样式模块', url);
                    if (typeof args.callback === 'function') args.callback();

                }, args.className);
            } else {
                Common.initTplandThemeHandle(state.$appConfig, function () {
                    Common.loadCSS(handle.getCustomCssUrl(state), function () {
                        console.log('VERSION=>', state.$appConfig.version);
                        console.log('CONFIG_PARAMS(ok)=>', JSON.stringify(state.$appConfig.PARAMS));
                        commit('SET_AJAX_STATUS', ['cssInit', true]);
                        commit('SET_FOOTER_URL');
                        commit('CHANGE_MODUL_LIST'); //更新展示模块方法
                    });
                });
            }
        }
    },

    mutations : {

        /**
         * 更新渠道配置
         * @param state
         * @param status
         * @constructor
         */
        SET_NO_CHANNEL_DATA(state, status){
            state.$noChannelData = status;
            console.log('state.$noChannelData=>', state.$noChannelData)
        },

        /**
         * 更新页面底部地址
         * @param state
         * @constructor
         */
        SET_FOOTER_URL(state){
            console.info(state, 'state')
            state.$footerUrl = handle.getFooterUrl(state);
        },

       /**
         * 更新AJAX状态
         * @param state
         * @param args
         * @constructor
         */
        SET_AJAX_STATUS(state, args){
            state.$pageLoadAjaxDone[args[0]] = args[1];
            handle.updateAjax(state);
            console.log(`AJAX_LOAD_DONE(${args[0]})=>`, JSON.stringify(state.$pageLoadAjaxDone));
        },

        /**
         * 更新loading显示状态
         * @param state
         * @param status
         * @constructor
         */
        LOADING(state, status){
            state.$pageLoadedIcon = status;
        },

        /**
         * 更新loading显示状态
         * @param state
         * @param status
         * @constructor
         */
        PACKAGE_LOADING(state, status) {
            console.log('PACKAGE_LOADING',status);
            state.$packageLoadedDoen = status;
        },

        /**
         * 更新关闭弹出UI
         * @param state
         * @param args
         * @constructor
         */
        CHANGE_POP_CLOSE_STATUS(state, args){
            state.$popStatus = args;
        },

        /**
         * 更新显示弹出UI
         * @param state
         * @param args
         * @constructor
         */
        CHANGE_POP_SHOW_HANDLE(state, args){
            state.$popStatus = args;
        },

        /**
         * 触发弹出UI确认按钮执行事件
         * @param state
         * @param args
         * @constructor
         */
        POP_CONFIRM_HANDLE(state, args){
           if(typeof  state.$popStatus.callback == 'function'){
               state.$popStatus.callback(state,args);
           }
        },

        /**
         * 更新访问模块和使用样式
         * @param state
         * @param args
         * @constructor
         */
        CHANGE_MODUL_LIST(state, args){
            console.log('state.$appConfig=>',state.$appConfig);
            let $modul = state.$appConfig.TPL[state.$appConfig.PARAMS.tpl];

            //检查国家模块是否有用户自定义显示配置，有配置启用应用自定义配置显示
            let countryModuleCustomData = state.$common.countryModuleCustomData;
            if(countryModuleCustomData[state.$appConfig.PARAMS.merchant_shop_code]&&
                state.$appConfig.PARAMS.theme === 't2' && state.$appConfig.PARAMS.tpl === 't2'
            ){
                $modul.country = countryModuleCustomData[state.$appConfig.PARAMS.merchant_shop_code].country;
                state.$countryModuleCustomData = countryModuleCustomData[state.$appConfig.PARAMS.merchant_shop_code].data;
            }

            state.$modulList = $modul;
            console.log('state.$modulList=>', state.$modulList);
            console.log('state.$countryModuleCustomData=>', state.$countryModuleCustomData);
        },


    }
});

export default store;



// WEBPACK FOOTER //
// ./website/store/app.js